/**
 * NK header — mobile drawer, desktop mega menu, header height CSS vars.
 */
(function () {
  'use strict';

  function setHeaderGroupHeight() {
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    let total = 0;
    for (let i = 0; i < headerGroup.children.length; i++) {
      const child = headerGroup.children[i];
      if (child instanceof HTMLElement) total += child.offsetHeight;
    }

    document.body.style.setProperty('--header-group-height', `${total}px`);

    const nkHeader = headerGroup.querySelector('.nk-header__shell');
    if (nkHeader) {
      document.body.style.setProperty('--header-height', `${nkHeader.offsetHeight}px`);
    }
  }

  function initNkHeader(root) {
    if (!root || root.dataset.nkHeaderInit) return;
    root.dataset.nkHeaderInit = 'true';

    const toggle = root.querySelector('[data-nk-header-toggle]');
    const drawer = root.querySelector('[data-nk-header-drawer]');
    if (!toggle || !drawer) return;

    function setOpen(isOpen) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      drawer.hidden = !isOpen;
      if (isOpen) {
        root.setAttribute('data-drawer-open', '');
      } else {
        root.removeAttribute('data-drawer-open');
      }
    }

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      setOpen(!isOpen);
    });

    const mq = window.matchMedia('(min-width: 990px)');
    function handleMq(e) {
      if (e.matches) setOpen(false);
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', handleMq);
    } else if (mq.addListener) {
      mq.addListener(handleMq);
    }

    drawer.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') setOpen(false);
    });

    root.querySelectorAll('[data-nk-open-cart-drawer]').forEach((btn) => {
      btn.addEventListener('click', () => {
        setOpen(false);
        const cartDrawer = document.querySelector('.nk-header__cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      });
    });

    root.querySelectorAll('[data-nk-open-search-modal]').forEach((btn) => {
      btn.addEventListener('click', () => {
        setOpen(false);
        const searchModal = document.getElementById('search-modal');
        if (searchModal && typeof searchModal.showDialog === 'function') {
          searchModal.showDialog();
        }
      });
    });

    root.querySelectorAll('[data-nk-drawer-mega-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panelId = btn.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        const item = btn.closest('.nk-header__drawer-item--mega');
        if (!panel || !item) return;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
        if (isOpen) {
          item.removeAttribute('data-drawer-mega-open');
        } else {
          item.setAttribute('data-drawer-mega-open', '');
        }
      });
    });

    const megaItems = root.querySelectorAll('[data-nk-mega-item]');
    let closeMegaTimer = null;

    function closeAllMega(exceptItem) {
      megaItems.forEach((item) => {
        if (exceptItem && item === exceptItem) return;
        item.removeAttribute('data-mega-open');
        const trigger = item.querySelector('[data-nk-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function openMega(item) {
      if (!item || window.matchMedia('(min-width: 990px)').matches === false) return;
      closeAllMega(item);
      item.setAttribute('data-mega-open', '');
      const trigger = item.querySelector('[data-nk-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    megaItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (closeMegaTimer) {
          clearTimeout(closeMegaTimer);
          closeMegaTimer = null;
        }
        openMega(item);
      });

      item.addEventListener('mouseleave', () => {
        closeMegaTimer = setTimeout(() => {
          item.removeAttribute('data-mega-open');
          const trigger = item.querySelector('[data-nk-mega-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, 120);
      });

      item.addEventListener('focusin', () => {
        openMega(item);
      });

      item.addEventListener('focusout', (e) => {
        if (item.contains(e.relatedTarget)) return;
        item.removeAttribute('data-mega-open');
        const trigger = item.querySelector('[data-nk-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllMega();
    });
  }

  function initAll() {
    document.querySelectorAll('.nk-header__shell').forEach(initNkHeader);
    setHeaderGroupHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', setHeaderGroupHeight);

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('.nk-header__shell').forEach(initNkHeader);
    }
  });
})();
